/** Ephemeral, opt-in observation point. No network, cookies or persistent IDs. */
export function emitLandingCta(
  location: "navigation" | "hero" | "plans" | "footer",
) {
  window.dispatchEvent(
    new CustomEvent("4apex:product-event", {
      detail: {
        schema_version: 1,
        kind: "landing_cta_clicked",
        traffic_kind: "acquisition",
        location,
        variant: "documentation_apex_v1",
        occurred_at: new Date().toISOString(),
      },
    }),
  );
}
